<h1 class="border-gray border-bottom text-center pb-4 mb-5">Galleries</h1>
<div class="text-end mb-4">
	<button (click)="create()"
		class="btn btn-round btn-slim btn-primary">
		Create gallery
	</button>
</div>
<div class="card border-0 bg-white shadow-sm mb-4">
	<div class="card-body p-xl-5">
		<div *ngIf="items.length"
			class="row">
			<div class="col-12">
				<div class="table-responsive">
					<table *ngIf="items.length"
						class="table table-borderless align-middle custom-wrap">
						<thead>
							<tr>
								<th class="text-primary fs-5 fw-600 text-nowrap">Gallery name</th>
								<th class="text-primary fs-5 fw-600 text-nowrap">Created</th>
								<th class="text-primary fs-5 fw-600 text-nowrap">Images</th>
								<th class="text-primary fs-5 fw-600 text-nowrap">Status</th>
								<th class="text-primary fs-5 fw-600 text-nowrap">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of items; let i = index; odd as isOdd"
								[ngClass]="{'tr-odd': isOdd}"
								class="toplined">
								<td (click)="update(item)">
									<span>{{item.name}}</span>
								</td>
								<td (click)="update(item)">
									{{item.createdAt | date:'dd MMM yyyy'}}
								</td>
								<td>
									<small [ngClass]="{'label-danger' : item.totalSnippets === 0, 'label-success' : item.totalSnippets > 0}"
										class="label">
										{{item.totalImages}}
									</small>
								</td>
								<td>
									<a (click)="setStatus(item)">
										<small *ngIf="!item.status"
											class="label label-danger">
											Inactive
										</small>
										<small *ngIf="item.status"
											class="label label-success">
											Active
										</small>
									</a>
								</td>
								<td class="text-end">
									<a (click)="update(item)">
										<img src="assets/images/icon-edit.svg" class="custom-edit-icon">
									</a>
									<a (click)="deleteConfirm(item)"
										class="ms-2">
										<img src="assets/images/icon-trash.svg" class="custom-delete-icon">
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<app-confirmation *ngIf="this.confirmationData.open"
		[data]="confirmationData"
		(complete)="confirmAction($event)"></app-confirmation>
</div>
